var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/affiliation/AffiliationModel',['require','underscore','evertrue','ET/ETModel'],function(require) {
  var AffiliationModel, ETModel, EverTrue, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETModel = require("ET/ETModel");
  return AffiliationModel = (function(_super) {
    __extends(AffiliationModel, _super);

    function AffiliationModel() {
      return AffiliationModel.__super__.constructor.apply(this, arguments);
    }

    AffiliationModel.prototype.urlRoot = "auth/affiliations";

    AffiliationModel.prototype.updateAffiliationContact = function(contact_id, done) {
      var options;
      options = {
        data: JSON.stringify({
          contact_id: contact_id
        }),
        contentType: "application/json",
        success: function(resp) {
          EverTrue.alertView.alert("success", {
            message: "Affiliation Updated"
          });
          if (_.isFunction(done)) {
            return done(resp.toJSON());
          }
        },
        error: function() {
          if (_.isFunction(done)) {
            return done();
          }
        }
      };
      return this.save({}, options);
    };

    AffiliationModel.prototype.updateAffiliationContactAndRoles = function(contact_id, roles, done) {
      var aff_data, options;
      aff_data = {
        contact_id: contact_id,
        role_ids: roles
      };
      options = {
        data: JSON.stringify(aff_data),
        contentType: "application/json",
        success: function(resp) {
          EverTrue.alertView.alert("success", {
            message: "Affiliation Updated"
          });
          if (_.isFunction(done)) {
            return done(resp.toJSON());
          }
        },
        error: function() {
          if (_.isFunction(done)) {
            return done();
          }
        }
      };
      return this.save({}, options);
    };

    AffiliationModel.prototype.updateRoles = function(role_ids, done) {
      var options;
      options = {
        data: JSON.stringify({
          role_ids: role_ids
        }),
        contentType: "application/json",
        success: function() {
          EverTrue.alertView.alert("success", {
            message: "Roles Updated Successfully"
          });
          if (_.isFunction(done)) {
            return done();
          }
        }
      };
      return this.save({}, options);
    };

    AffiliationModel.prototype.deleteAffiliation = function(done) {
      var options;
      options = {
        complete: function() {
          EverTrue.alertView.alert("success", {
            message: "Affiliation Deleted"
          });
          if (_.isFunction(done)) {
            return done();
          }
        }
      };
      return this.destroy(options);
    };

    AffiliationModel.prototype.createAffiliation = function(options) {
      var api_options;
      api_options = _.extend({
        url: this.urlRoot,
        type: "POST",
        contentType: "application/json",
        success: (function(_this) {
          return function(resp) {
            return _this.set(resp);
          };
        })(this)
      }, options);
      return EverTrue.api(api_options, this);
    };

    return AffiliationModel;

  })(ETModel);
});

//# sourceMappingURL=AffiliationModel.js.map
;
